/// May be useful as it's own util?
const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const convertInlineToReactCSS = (inline: string): { [key: string]: string } => {
  try {
    const rules = inline.split(';');

    const styleObject = {};
    rules.forEach(item => {
      if (item) {
        let [key, value] = item.split(':');

        if (typeof key === 'string' && typeof value === 'string') {
          key = key.trim();
          value = value.trim();

          if (key && value) {
            if (key[0] === '-') {
              styleObject[key] = value;
            } else {
              let splitKey = key.split('-');

              if (splitKey.length > 1) {
                const keyPrefix = splitKey[0];
                splitKey.splice(0, 1);

                splitKey = splitKey.map(item => capitalizeFirstLetter(item));
                styleObject[keyPrefix + splitKey] = value;
              } else {
                styleObject[key] = value;
              }
            }
          }
        }
      }
    });

    return styleObject;
  } catch (e) {
    console.log('STYLE CONVERT ERROR:', e);

    return {};
  }
};
